module.exports = __webpack_public_path__ + "img/test4.2cb1487b.png";